/* ───────────────────────────────────────────────────────────────
   ZENVRE — movimiento
   Sin librerías: IntersectionObserver para las apariciones y
   rAF para el paralaje. Pesa 2 KB en vez de los 60 de GSAP+Lenis,
   y no se pelea con el JS propio de Horizon.
   ─────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto) return;

  /* ── 1. Aparición al entrar en pantalla ───────────────────── */
  function marcar() {
    var grupos = [
      ['.zv-edit > *', 1],
      ['.zv-paso', 1],
      ['.zv-port__pie > *', 1],
      ['.resource-card', 1]
    ];
    grupos.forEach(function (g) {
      var els = document.querySelectorAll(g[0]);
      Array.prototype.forEach.call(els, function (el, i) {
        if (el.classList.contains('zv-rev')) return;
        el.classList.add('zv-rev');
        el.setAttribute('data-i', String(Math.min(i, 4)));
      });
    });
  }

  var observador = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('esta');
        observador.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function observar() {
    marcar();
    Array.prototype.forEach.call(document.querySelectorAll('.zv-rev:not(.esta)'), function (el) {
      observador.observe(el);
    });
  }

  /* ── 2. Paralaje de la portada ─────────────────────────────
     La foto avanza al 88 % de la página: suficiente para notar
     profundidad, poco para marear. */
  var media = null, pendiente = false;

  function pintar() {
    pendiente = false;
    if (!media) return;
    var caja = media.getBoundingClientRect();
    if (caja.bottom < 0 || caja.top > window.innerHeight) return;
    var avance = (window.innerHeight - caja.top) / (window.innerHeight + caja.height);
    var y = (avance - 0.5) * 34; // píxeles de recorrido
    media.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0) scale(1.06)';
  }

  function alHacerScroll() {
    if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); }
  }

  /* ── 3. Inclinación 3D de las tarjetas con el ratón ────────
     Cuatro grados como máximo. Si se nota el truco, está mal. */
  function inclinar(tarjeta) {
    var enlace = tarjeta.querySelector('.resource-card__link');
    if (!enlace) return;
    var dentro = false;

    tarjeta.addEventListener('pointerenter', function () { dentro = true; }, { passive: true });
    tarjeta.addEventListener('pointermove', function (ev) {
      if (!dentro || ev.pointerType !== 'mouse') return;
      var c = tarjeta.getBoundingClientRect();
      var px = (ev.clientX - c.left) / c.width - 0.5;
      var py = (ev.clientY - c.top) / c.height - 0.5;
      enlace.style.transform =
        'translate3d(0,-5px,0) rotateY(' + (px * 4).toFixed(2) + 'deg) rotateX(' +
        (-py * 4).toFixed(2) + 'deg)';
    }, { passive: true });
    tarjeta.addEventListener('pointerleave', function () {
      dentro = false;
      enlace.style.transform = '';
    }, { passive: true });
  }

  /* ── Portada: el nombre se graba mientras lo escribe ───────
     Y se lo guardamos, para que no tenga que escribirlo otra vez
     cuando llegue a la pieza. */
  var LLAVE_NOMBRE = 'zv-nombre';

  function guardarNombre(v) {
    try {
      if (v) { sessionStorage.setItem(LLAVE_NOMBRE, v); }
      else { sessionStorage.removeItem(LLAVE_NOMBRE); }
    } catch (e) {}
  }
  function nombreGuardado() {
    try { return sessionStorage.getItem(LLAVE_NOMBRE) || ''; } catch (e) { return ''; }
  }

  function portada() {
    var raiz = document.querySelector('.zv-grab');
    if (!raiz || raiz.dataset.zvListo) return;
    var campo = raiz.querySelector('.zv-grab__campo');
    var letras = raiz.querySelector('.zv-grab__nombre');
    if (!campo || !letras) return;
    raiz.dataset.zvListo = '1';
    var vacio = letras.getAttribute('data-vacio') || 'TU PERRO';

    function pintar() {
      var v = campo.value.trim();
      var t = v || vacio;
      letras.textContent = t;
      /* los nombres largos bajan de cuerpo para no partirse */
      letras.className = 'zv-grab__nombre' +
        (t.length > 13 ? ' es-xl' : (t.length > 8 ? ' es-l' : ''));
      guardarNombre(v);
    }
    campo.addEventListener('input', pintar);
    var g = nombreGuardado();
    if (g && !campo.value) campo.value = g;
    pintar();
  }

  /* En la ficha, el nombre ya viene puesto si lo escribio en la portada. */
  function traerNombre() {
    if (location.pathname.indexOf('/products/') !== 0) return;
    var i = document.querySelector('input[name="properties[Nombre del perro]"]');
    if (!i || i.value) return;
    var g = nombreGuardado();
    if (!g) return;
    i.value = g;
    /* sin esto el contador de caracteres del tema se queda en cero */
    i.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function arrancar() {
    observar();
    portada();
    traerNombre();   /* primero se rellena el campo... */
    confianza();    /* ...y luego se pinta el aviso con el campo ya puesto */
    media = document.querySelector('.zv-port__media');
    if (media) { alHacerScroll(); window.addEventListener('scroll', alHacerScroll, { passive: true }); }
    Array.prototype.forEach.call(document.querySelectorAll('.resource-card'), inclinar);
  }

  /* ── 4. Red de seguridad ───────────────────────────────────
     Si por lo que sea el observador no dispara, a los 2,5 s se
     muestra todo. Una animación que falla no puede dejar la
     tienda en blanco. */
  setTimeout(function () {
    Array.prototype.forEach.call(document.querySelectorAll('.zv-rev:not(.esta)'),
      function (el) { el.classList.add('esta'); });
  }, 2500);

  /* ── 5. Lo que quita el miedo justo donde se decide ────────
     Las tres dudas que frenan una compra de 79 euros a un
     desconocido: cuándo llega, qué pasa si no me gusta, y quién
     está detrás. Van debajo del botón, no en una página aparte. */
  function confianza() {
    /* Solo en la ficha del producto. En la home cada tarjeta lleva su propio
       boton de compra rapida, y sin esto la barra se colaba dentro de todas. */
    if (location.pathname.indexOf('/products/') !== 0) return;
    var raiz = document.getElementById('shopify-section-main') ||
               document.querySelector('[id*="MainProduct"], main') || document;
    var form = raiz.querySelector('.add-to-cart-button, [class*="add-to-cart"]');
    if (!form || document.querySelector('.zv-confianza')) return;
    var caja = form.closest('form') || form.parentElement;
    if (!caja) return;
    var d = document.createElement('div');
    d.className = 'zv-confianza';
    d.innerHTML =
      '<div><b>Sale en 3 a 5 días</b><span>Se fabrica cuando lo pides</span></div>' +
      '<div class="zv-conf-dev"></div>' +
      '<div><b>Fabricado en España</b><span>Una a una, por encargo</span></div>';
    caja.appendChild(d);

    /* El aviso de devolución no es fijo: si escribe el nombre de su perro,
       la pieza pasa a ser personalizada y la ley la deja fuera del
       desistimiento. Que lo vea mientras escribe, no en la letra pequeña. */
    var campo = raiz.querySelector('input[name="properties[Nombre del perro]"]');
    var hueco = d.querySelector('.zv-conf-dev');
    /* guardar solo cuando escribe el. Al pintar la primera vez el campo
       aun puede estar vacio, y guardar ahi borraria el nombre que traia
       de la portada. */
    function pintarDevolucion(guardar) {
      var puesto = campo ? campo.value.trim() : '';
      var conNombre = puesto.length > 0;
      if (guardar) guardarNombre(puesto);
      hueco.innerHTML = conNombre
        ? '<b>Lleva su nombre</b><span>Pieza personalizada, sin devolución</span>'
        : '<b>15 días para devolverlo</b><span>Sin dar explicaciones</span>';
    }
    if (campo) campo.addEventListener('input', function () { pintarDevolucion(true); });
    pintarDevolucion(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* Horizon pinta secciones por su cuenta: volvemos a observar. */
  document.addEventListener('shopify:section:load', arrancar);
})();
